import { useLayoutEffect, useEffect, useRef } from "react"
import { Helmet } from "react-helmet-async"
import gsap from "gsap"

import Nav from "../Nav/Nav"
import Sidebar from '../Sidebar/Sidebar'
import ProjectsLink from "./ProjectsLink"
import Footer from '../Footer/Footer'

const Projects = ({sidebarIsOpen, setSidebarIsOpen, data}) =>
{
    // refs
    const titleRef = useRef()
    const subRef = useRef()
    const projectsRef = useRef()
    const overlayRef = useRef()

    // Close sidebar
    useEffect(()=>{
        setSidebarIsOpen(false)
    },[])

     // Scroll to top
    useLayoutEffect(()=>{
        window.scrollTo({
            top:0,
            left:0,
            behavior:'smooth'
        })
    },[])

    useEffect(()=>{
        gsap.to(overlayRef.current, {duration:1, scaleX:0, transformOrigin: 'right', ease: "expo.in"})
        gsap.fromTo(titleRef.current, {y: 500}, {delay:1, duration:0.3, y:0, ease: "expo.out"})
        gsap.fromTo(subRef.current, {y: 500}, {delay:1.2, duration:0.3, y:0, ease: "expo.out"})
        gsap.fromTo(projectsRef.current, {y: 500}, {delay:1.4, duration:0.3, y:0, ease: "expo.out"})
    },[])
    
    return(
        <div className="projects">
            <Helmet>
                <title>Antino Kila - Work</title>
                <meta name='description' content='This is Antino Kila, a creative frontend developer based in United Kingdom.' />
            </Helmet>

            <div className="projects-overlay" ref={overlayRef}></div>

            <Nav sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
            {sidebarIsOpen? <Sidebar /> : ""}

            <h1 ref={titleRef}>Work</h1>
            <p ref={subRef} className="projects-p">A collection of work and personal projects including full stack web applications, frontent development, web design & 3D design.</p>

            <div ref={projectsRef} className="projects-links">
                {data.map( project =>
                    <ProjectsLink key={project.id} project={project} />
                )}
            </div>

            <Footer />
        </div>
    )
}

export default Projects